import { Marketplace, Product, DashboardStats, Order } from '../types';

export const marketplaces: Marketplace[] = [
  { id: 'ml', name: 'Mercado Livre', logo: '🛒', status: 'active', color: '#FFE600' },
  { id: 'leroy', name: 'Leroy Merlin', logo: '🏠', status: 'active', color: '#78BE20' },
  { id: 'magalu', name: 'Magazine Luiza', logo: '🛍️', status: 'active', color: '#0086FF' },
  { id: 'casas', name: 'Casas Bahia', logo: '🏡', status: 'error', color: '#FF6000' },
  { id: 'amazon', name: 'Amazon', logo: '📦', status: 'active', color: '#FF9900' },
  { id: 'shopee', name: 'Shopee', logo: '🛍️', status: 'active', color: '#EE4D2D' },
];

export const mockProducts: Product[] = [
  {
    id: '1',
    sku: '197094188384',
    title: 'Sunny Breeze Maxi Dress 2025 - Light Blue',
    description: 'Introducing the Summer Breeze Maxi Dress: Effortlessly stylish and comfortable',
    image: '/api/placeholder/80/80',
    category: 'Fashion > Women > Dresses',
    brand: 'Summer Collection',
    basePrice: 89.90,
    stock: 150,
    mappingStatus: 'complete',
    createdAt: '2025-01-15',
    updatedAt: '2025-02-09',
    channels: [
      {
        marketplaceId: 'ml',
        marketplaceName: 'Mercado Livre',
        status: 'synced',
        price: 89.90,
        stock: 50,
        lastSync: '2025-02-09T10:30:00',
      },
      {
        marketplaceId: 'magalu',
        marketplaceName: 'Magazine Luiza',
        status: 'synced',
        price: 89.90,
        stock: 50,
        lastSync: '2025-02-09T10:25:00',
      },
      {
        marketplaceId: 'amazon',
        marketplaceName: 'Amazon',
        status: 'error',
        price: 89.90,
        stock: 50,
        lastSync: '2025-02-09T09:15:00',
        errors: [
          {
            code: 'DESCRIPTION_TOO_LONG',
            message: 'A descrição excede o limite de 2000 caracteres',
            field: 'description',
            severity: 'error',
            timestamp: '2025-02-09T09:15:00',
          },
        ],
      },
    ],
  },
  {
    id: '2',
    sku: '197094188385',
    title: 'Ocean Wave Flowy Dress - 100% Cotton',
    description: 'The Sunlit Floral Wrap Dress features vibrant colors and a flattering silhouette',
    image: '/api/placeholder/80/80',
    category: 'Fashion > Women > Dresses',
    brand: 'Ocean Style',
    basePrice: 79.90,
    stock: 200,
    mappingStatus: 'complete',
    createdAt: '2025-01-20',
    updatedAt: '2025-02-08',
    channels: [
      {
        marketplaceId: 'ml',
        marketplaceName: 'Mercado Livre',
        status: 'synced',
        price: 79.90,
        stock: 80,
        lastSync: '2025-02-08T15:20:00',
      },
      {
        marketplaceId: 'shopee',
        marketplaceName: 'Shopee',
        status: 'synced',
        price: 79.90,
        stock: 70,
        lastSync: '2025-02-08T15:18:00',
      },
      {
        marketplaceId: 'leroy',
        marketplaceName: 'Leroy Merlin',
        status: 'pending',
        price: 79.90,
        stock: 50,
        lastSync: '2025-02-07T10:00:00',
      },
    ],
  },
  {
    id: '3',
    sku: '197094188386',
    title: 'Tropical Paradise Sundress - Stylish and Comfortable',
    description: 'Discover the Coastal Chic Sundress, designed with lightweight fabric perfect for summer',
    image: '/api/placeholder/80/80',
    category: 'Fashion > Women > Dresses',
    brand: 'Paradise',
    basePrice: 99.90,
    stock: 120,
    mappingStatus: 'partial',
    createdAt: '2025-01-25',
    updatedAt: '2025-02-09',
    channels: [
      {
        marketplaceId: 'amazon',
        marketplaceName: 'Amazon',
        status: 'synced',
        price: 99.90,
        stock: 60,
        lastSync: '2025-02-09T11:00:00',
      },
      {
        marketplaceId: 'casas',
        marketplaceName: 'Casas Bahia',
        status: 'error',
        price: 99.90,
        stock: 60,
        lastSync: '2025-02-08T08:30:00',
        errors: [
          {
            code: 'TOKEN_EXPIRED',
            message: 'Token de autenticação expirado',
            severity: 'error',
            timestamp: '2025-02-08T08:30:00',
          },
        ],
      },
    ],
  },
];

export const dashboardStats: DashboardStats = {
  totalProducts: 918072,
  activeProducts: 682000,
  productsWithErrors: 938,
  pendingMappings: 0,
  totalOrders: 1543,
  ordersToday: 87,
  revenue: 458900.50,
  revenueChange: 12.5,
  syncStatus: {
    price: true,
    discountPrice: true,
    stock: true,
    productData: true,
    lastSync: '2025-02-09T11:30:00',
  },
  channelDistribution: [
    { marketplaceId: 'ml', marketplaceName: 'Mercado Livre', productCount: 250000, percentage: 27.2, color: '#FFE600' },
    { marketplaceId: 'magalu', marketplaceName: 'Magazine Luiza', productCount: 180000, percentage: 19.6, color: '#0086FF' },
    { marketplaceId: 'amazon', marketplaceName: 'Amazon', productCount: 150000, percentage: 16.3, color: '#FF9900' },
    { marketplaceId: 'shopee', marketplaceName: 'Shopee', productCount: 120000, percentage: 13.1, color: '#EE4D2D' },
    { marketplaceId: 'leroy', marketplaceName: 'Leroy Merlin', productCount: 110000, percentage: 12.0, color: '#78BE20' },
    { marketplaceId: 'casas', marketplaceName: 'Casas Bahia', productCount: 108072, percentage: 11.8, color: '#FF6000' },
  ],
  recentErrors: [
    {
      code: 'DESCRIPTION_TOO_LONG',
      message: 'Produto SKU 197094188384: descrição excede 2000 caracteres no Magazine Luiza',
      field: 'description',
      severity: 'error',
      timestamp: '2025-02-09T11:15:00',
    },
    {
      code: 'TOKEN_EXPIRED',
      message: 'Token de autenticação expirado na Casas Bahia',
      severity: 'error',
      timestamp: '2025-02-09T10:45:00',
    },
    {
      code: 'STOCK_MISMATCH',
      message: 'Produto SKU 197094188350: divergência de estoque no Mercado Livre',
      field: 'stock',
      severity: 'warning',
      timestamp: '2025-02-09T10:30:00',
    },
    {
      code: 'CATEGORY_NOT_MAPPED',
      message: 'Categoria "Eletrônicos > Áudio" não mapeada para Amazon',
      severity: 'warning',
      timestamp: '2025-02-09T09:50:00',
    },
    {
      code: 'PRICE_VALIDATION',
      message: 'Produto SKU 197094188299: preço abaixo do mínimo permitido na Shopee',
      field: 'price',
      severity: 'error',
      timestamp: '2025-02-09T09:20:00',
    },
  ],
};

export const mockOrders: Order[] = [
  {
    id: 'ORD-001',
    orderNumber: 'ML-2025-001234',
    marketplaceId: 'ml',
    marketplaceName: 'Mercado Livre',
    customer: {
      name: 'Maria Silva',
      email: 'maria.silva@email.com',
      phone: '+55 11 98765-4321',
    },
    items: [
      {
        sku: '197094188384',
        title: 'Sunny Breeze Maxi Dress 2025',
        quantity: 2,
        price: 89.90,
        image: '/api/placeholder/60/60',
      },
    ],
    total: 179.80,
    status: 'confirmed',
    paymentStatus: 'paid',
    shippingStatus: 'preparing',
    createdAt: '2025-02-09T10:30:00',
    updatedAt: '2025-02-09T10:35:00',
  },
  {
    id: 'ORD-002',
    orderNumber: 'MGLU-2025-005678',
    marketplaceId: 'magalu',
    marketplaceName: 'Magazine Luiza',
    customer: {
      name: 'João Santos',
      email: 'joao.santos@email.com',
    },
    items: [
      {
        sku: '197094188385',
        title: 'Ocean Wave Flowy Dress',
        quantity: 1,
        price: 79.90,
      },
    ],
    total: 79.90,
    status: 'shipped',
    paymentStatus: 'paid',
    shippingStatus: 'in_transit',
    createdAt: '2025-02-08T14:20:00',
    updatedAt: '2025-02-09T08:15:00',
  },
];
